import { Plugin } from '@nuxt/types';
import Clipboard from 'clipboard';

declare module 'vue/types/vue' {
  interface Vue {
    $clipboard(text: string): string;
  }
}

const plugin: Plugin = (_, inject) => {
  inject('clipboard', (text: string) => Clipboard.copy(text));
};

export default plugin;
